import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('OrderReduction', OrderReductionData);

    function OrderReductionData() {
        OrderReduction.prototype = {
            build: build
        };

        function OrderReduction(orderReductionData) {
            if (orderReductionData) {
                this.build(orderReductionData);
            }
        }

        return OrderReduction;

        /////////////////////

        function build(orderReductionData) {
            this.amount = orderReductionData.amount || null;
            this.reason = orderReductionData.reason || null;
        }
    }
})();
